module.exports = __webpack_public_path__ + "img/danamon.30fc0942.png";